import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';

const ArticleTiles = ({ rendering, params }: ComponentProps): JSX.Element => {
  const backgroundClass = params.background || 'background-white';
  const containerPadding = backgroundClass === 'background-white' ? 'p-0' : 'px-3 pt-6 pb-6';
  const size = rendering?.params?.size;
  const containerSize = size === 'default' || !size ? 'col-6' : size;

  return (
    <section className={`${backgroundClass} ${containerPadding}`}>
      <Placeholder
        headingSize="h3"
        name="abrdn-tiles-heading"
        className="mb-4"
        rendering={rendering}
      />
      <div className="row">
        <Placeholder
          insideArticleBody
          name="abrdn-article-tiles"
          rendering={rendering}
          containerSize={containerSize}
        />
      </div>
    </section>
  );
};

export default ArticleTiles;
